module.exports = __webpack_public_path__ + "img/rpqnrcyz_zcnr.eaed6703.png";